import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';

const VALUES = [
  { icon: 'ri-hd-line', title: '高清资源', desc: '聚焦高清影视内容，提供清晰的观影演示与详实的影片信息。' },
  { icon: 'ri-book-open-line', title: '剧情详解', desc: '完整的剧情介绍、演员与幕后信息，帮助影迷深入理解作品。' },
  { icon: 'ri-newspaper-line', title: '资讯速递', desc: '持续更新影视资讯、幕后花絮与深度解析，紧跟行业动态。' },
  { icon: 'ri-thumb-up-line', title: '精选推荐', desc: '基于题材标签整理相关影视作品，帮你更快找到想看的内容。' },
];

const CONTACTS = [
  { icon: 'ri-mail-line', label: '电子邮箱', value: 'contact@taboo4-demo.example' },
  { icon: 'ri-wechat-line', label: '微信公众号', value: '美国式禁忌4影视' },
  { icon: 'ri-weibo-line', label: '官方微博', value: '@美国式禁忌4' },
  { icon: 'ri-customer-service-2-line', label: '影迷交流', value: '欢迎在资讯页留言互动（演示）' },
];

export default function About() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <div className="h-16 md:h-[72px]" />

      <main className="flex-1">
        {/* 品牌介绍 Hero */}
        <section className="relative w-full bg-primary-950 text-white overflow-hidden">
          <div className="absolute inset-0 opacity-30">
            <img
              src="https://readdy.ai/api/search-image?query=Cinematic%20abstract%20film%20reel%20and%20projector%20light%20beams%20in%20a%20dark%20auditorium%2C%20deep%20indigo%20and%20charcoal%20tones%20with%20warm%20amber%20highlights%2C%20atmospheric%20dust%20particles%2C%20film%20grain%2C%20minimal%20elegant%20composition%20with%20negative%20space&width=1920&height=700&seq=about-hero-banner&orientation=landscape"
              alt="影视门户品牌背景"
              title="美国式禁忌4 品牌介绍"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="relative w-full px-4 md:px-8 py-16 md:py-24">
            <Breadcrumb items={[{ label: '关于我们' }]} tone="dark" />
            <h1 className="font-heading font-extrabold text-3xl md:text-5xl mt-6">关于美国式禁忌4</h1>
            <p className="mt-5 text-background-200 text-sm md:text-base leading-relaxed max-w-3xl">
              美国式禁忌4是一个以影视作品为核心的内容门户，专注于《美国式禁忌4》及其相关美剧、电影的高清观影演示、剧情介绍与资讯服务。
              我们希望为喜欢美剧与电影的观众，提供一个信息清晰、阅读舒适、浏览顺畅的影视信息平台。
            </p>
          </div>
        </section>

        <div className="w-full px-4 md:px-8 py-14 md:py-20">
          {/* 我们提供什么 */}
          <section>
            <div className="flex items-center gap-3 mb-8">
              <span className="w-10 h-10 rounded-md bg-accent-500 text-white flex items-center justify-center">
                <i className="ri-focus-3-line text-xl"></i>
              </span>
              <div>
                <p className="text-xs text-foreground-500 font-label uppercase tracking-widest">What We Offer</p>
                <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">我们提供什么</h2>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {VALUES.map((v) => (
                <div key={v.title} className="p-5 rounded-lg bg-background-100 border border-background-200/70">
                  <span className="w-11 h-11 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center mb-4">
                    <i className={`${v.icon} text-xl`}></i>
                  </span>
                  <h3 className="font-heading font-semibold text-base text-foreground-950">{v.title}</h3>
                  <p className="text-sm text-foreground-600 mt-2 leading-relaxed">{v.desc}</p>
                </div>
              ))}
            </div>
          </section>

          {/* 联系方式 */}
          <section className="mt-14 md:mt-20">
            <div className="flex items-center gap-3 mb-8">
              <span className="w-10 h-10 rounded-md bg-primary-500 text-white flex items-center justify-center">
                <i className="ri-contacts-book-line text-xl"></i>
              </span>
              <div>
                <p className="text-xs text-foreground-500 font-label uppercase tracking-widest">Contact</p>
                <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">联系我们</h2>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {CONTACTS.map((c) => (
                <div key={c.label} className="p-5 rounded-lg bg-background-100 border border-background-200/70">
                  <span className="w-11 h-11 rounded-md bg-secondary-100 text-secondary-900 flex items-center justify-center mb-4">
                    <i className={`${c.icon} text-xl`}></i>
                  </span>
                  <p className="text-xs text-foreground-500">{c.label}</p>
                  <p className="text-sm font-medium text-foreground-900 mt-1 break-all">{c.value}</p>
                </div>
              ))}
            </div>
            <p className="text-xs text-foreground-400 mt-4 flex items-center gap-1.5">
              <i className="ri-information-line"></i> 以上联系方式为演示示例，本站不提供真实客服与人工服务。
            </p>
          </section>

          {/* 使用声明 */}
          <section className="mt-14 md:mt-20">
            <div className="rounded-lg bg-background-100 border border-background-200/70 p-6 md:p-8">
              <div className="flex items-center gap-3 mb-5">
                <span className="w-10 h-10 rounded-md bg-accent-500 text-white flex items-center justify-center">
                  <i className="ri-shield-check-line text-xl"></i>
                </span>
                <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">使用声明与版权信息</h2>
              </div>
              <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-4xl">
                <p>
                  本站所有影视作品标题、剧情介绍、演员信息及资讯内容均为虚构演示示例，仅用于网站功能与界面展示，不代表任何真实影片或事件。
                </p>
                <p>
                  站内「在线观看」功能仅为前端演示播放窗口，不接入任何真实影视资源，不具备真实播放、缓存或下载能力，请勿将其视为可用的观影来源。
                </p>
                <p>
                  本站不提供用户注册、登录、支付或下载等后台服务。若未来需要支持相关功能，可通过连接后端服务进行扩展。
                </p>
                <p>
                  如需就内容授权、合作或反馈问题与我们联系，可通过上方邮箱沟通。感谢每一位影迷的理解与支持。
                </p>
              </div>
            </div>
          </section>

          <div className="mt-12 flex items-center flex-wrap gap-3">
            <Link
              to="/"
              className="px-5 py-2.5 rounded-md bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-home-4-line mr-1.5"></i> 返回首页
            </Link>
            <Link
              to="/category"
              className="px-5 py-2.5 rounded-md bg-background-100 border border-background-300 text-foreground-800 text-sm font-semibold hover:bg-background-200 transition-colors whitespace-nowrap"
            >
              浏览影视分类
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}